import { formatNumber } from "@/lib/utils";
import type { CampaignInfluencer } from "../types";

export const getAvgViews = (influencer: CampaignInfluencer): string => {
  const views = influencer.videoViewCount;
  if (views) return formatNumber(views * 2.65);
  const followers = influencer.followersCount;
  if (followers) return formatNumber(Math.round(followers * 0.15 * 2.65));
  return "-";
};

export const getSocialProfileUrl = (platform: string, handle: string): string => {
  const cleanHandle = handle.replace(/^@/, "");
  if (platform?.toLowerCase() === "youtube") {
    return `https://youtube.com/@${cleanHandle}`;
  }
  return `https://instagram.com/${cleanHandle}`;
};
